const constants = {
  set: 'BOARD_SET',
};

const set = (board) => ({
  type: constants.set,
  payload: board,
});

const boardActions = {
  constants,
  set,
};

export default boardActions;
